// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type UpdateJobHistoryLevelDefinitionsMutationVariables = Types.Exact<{
  input: Types.UpdateJobHistoryLevelDefinitionsInput;
}>;

export type UpdateJobHistoryLevelDefinitionsMutation = { __typename?: 'Mutation' } & {
  updateJobHistoryLevelDefinitions: { __typename?: 'JobHistoryLevelDefinitions' } & Pick<
    Types.JobHistoryLevelDefinitions,
    'level' | 'displayName'
  > & {
      definitions: Array<
        { __typename?: 'DefinitionItem' } & Pick<Types.DefinitionItem, 'languageCode' | 'displayName' | 'content'>
      >;
    };
};

export const UpdateJobHistoryLevelDefinitionsDocument = /*#__PURE__*/ gql`
    mutation updateJobHistoryLevelDefinitions($input: UpdateJobHistoryLevelDefinitionsInput!) {
  updateJobHistoryLevelDefinitions(input: $input) {
    level
    displayName
    definitions {
      languageCode
      displayName
      content
    }
  }
}
    `;
export type UpdateJobHistoryLevelDefinitionsMutationFn = Apollo.MutationFunction<
  UpdateJobHistoryLevelDefinitionsMutation,
  UpdateJobHistoryLevelDefinitionsMutationVariables
>;

/**
 * __useUpdateJobHistoryLevelDefinitionsMutation__
 *
 * To run a mutation, you first call `useUpdateJobHistoryLevelDefinitionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobHistoryLevelDefinitionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobHistoryLevelDefinitionsMutation, { data, loading, error }] = useUpdateJobHistoryLevelDefinitionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobHistoryLevelDefinitionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateJobHistoryLevelDefinitionsMutation,
    UpdateJobHistoryLevelDefinitionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateJobHistoryLevelDefinitionsMutation,
    UpdateJobHistoryLevelDefinitionsMutationVariables
  >(UpdateJobHistoryLevelDefinitionsDocument, options);
}
export type UpdateJobHistoryLevelDefinitionsMutationHookResult = ReturnType<
  typeof useUpdateJobHistoryLevelDefinitionsMutation
>;
export type UpdateJobHistoryLevelDefinitionsMutationOptions = Apollo.BaseMutationOptions<
  UpdateJobHistoryLevelDefinitionsMutation,
  UpdateJobHistoryLevelDefinitionsMutationVariables
>;
